import React from "react";
import { Route, Routes } from "react-router-dom";
import Testimonials from "../components/Templates/Testimonials";
import Projects from "../components/Templates/Projects";
import Skills from "../components/Templates/Skills";
import Contact from "../components/Templates/Contact";
import Header from "../components/Organisms/Header";
import Footer from "../components/Organisms/Footer";
import Index from "../components/Templates/Index";
import VantaBackground from "../components/Organisms/VantaBackground";

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  return (
    <>
      <VantaBackground />
      <Header />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </>
  );
};
export default Home;
